export const ReviewOrderLandingPageTemplate = {
    slots: ['SlbCheckoutContainerSlot'],
};